export default __webpack_public_path__ + "images/44014eb312289ac5472c3d14decbedc6-mountain_biking.jpg";